import type {StateCreator} from 'zustand'
import type {LayoutPullRequest, LayoutBaseRepository} from '../LayoutStore'

export interface LayoutPullRequestSlice {
  layoutPullRequest: LayoutPullRequest & {
    basePath: string
    baseRepository: LayoutBaseRepository
  }
}

export interface LayoutPullRequestSliceOpts {
  layoutPullRequest: {
    pullRequest: LayoutPullRequest
    basePath: string
    baseRepository: LayoutBaseRepository
  }
}

export const createLayoutPullRequestSlice =
  ({
    layoutPullRequest: {pullRequest, basePath, baseRepository},
  }: LayoutPullRequestSliceOpts): StateCreator<
    LayoutPullRequestSlice,
    [['zustand/devtools', never]],
    [],
    LayoutPullRequestSlice
  > =>
  () => ({
    layoutPullRequest: {
      ...pullRequest,
      basePath,
      baseRepository,
    },
  })
